<div class="si-appo-arrival-confirm-button">
  <ng-container *ngIf="actions?.includes('SHOW_WAITING_ROOM'); else manageConfirmButton">
    <si-go-to-route-button [href]="['/appointment/waiting-room']"
                           text="SI_VIEW_MY_TURN"
                           styleClass="si-button_main w-100"
    ></si-go-to-route-button>
  </ng-container>
  <ng-template #manageConfirmButton>
    <ng-container *ngIf="!actions?.includes('IS_ARRIVAL_CONFIRMABLE') || isLate(); else confirmButton">
      <button class="si-button_disabled-grey w-100"
              type="button"
              [disabled]="true">
        <span>{{'SI_GO_ADMISSION_DESK' | translate}}</span>
      </button>
    </ng-container>
    <ng-template #confirmButton>
      <button class="si-button_green w-100"
              type="button"
              [disabled]="isSoon()"
              (click)="onClickConfirmButton()">
        <span>{{'SI_CONFIRM_ARRIVAL' | translate}}</span>
      </button>
    </ng-template>
  </ng-template>
</div>
<ng-container *ngIf="displayConfirmArrivalDialog">
  <si-appo-arrival-confirm-dialog [(displayDialog)]="displayConfirmArrivalDialog"
                                  [appoId]="appoId"
                                  [centerAddress]="centerAddress"
                                  [centerName]="centerName"
                                  [centerLatitude]="centerLatitude"
                                  [centerLongitude]="centerLongitude"
                                  [cardNumberSEOGA]="cardNumberSEOGA"
                                  [actions]="actions"
                                  (appoArrivalConfirmed)="onConfirmArrival()"
  ></si-appo-arrival-confirm-dialog>
</ng-container>
